import { object } from 'yup';

import { dateOfServiceSchema, notesSchema } from './form-risk-entry.schema';

export const dataSchema = object({
  notes: notesSchema,
  dateOfService: dateOfServiceSchema,
});

export const bulkFormRiskEntrySchema = object({
  data: dataSchema,
});
